import type { RxJsonSchema } from 'rxdb';
import type { StockAdjustmentDocType } from '../types/stockAdjustment';

export const stockAdjustmentSchema: RxJsonSchema<StockAdjustmentDocType> = {
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 36 },
    productId: { type: 'string', maxLength: 36 },
    adjustmentType: { type: 'string', enum: ['increase', 'decrease'] },
    quantity: { type: 'number' },
    reason: { 
      type: 'string', 
      enum: ['stock_opname', 'damage', 'loss', 'found', 'correction', 'other'] 
    },
    notes: { type: 'string' },
    approvedBy: { type: 'string', maxLength: 36 },
    status: { type: 'string', enum: ['pending', 'approved', 'rejected'] },
    createdBy: { type: 'string', maxLength: 36 },
    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    _deleted: { type: 'boolean', default: false },
  },
  required: ['id', 'productId', 'adjustmentType', 'quantity', 'reason', 'status', 'createdAt', 'updatedAt'],
};
